import React, { useEffect } from 'react';
import { Button as BsButton } from 'react-bootstrap';

function Button( {children, ...rest}) {
    useEffect(() => {
        const createRipple = (e) => {
            const element = e.currentTarget;
            const rippleDiv = document.createElement('span');
            rippleDiv.className = 'ripple-overlay';
            const rippleOffset = element.getBoundingClientRect();
            const rippleY = e.clientY - rippleOffset.top;
            const rippleX = e.clientX - rippleOffset.left;
            rippleDiv.style.top = `${rippleY - rippleDiv.offsetHeight / 2}px`;
            rippleDiv.style.left = `${rippleX - rippleDiv.offsetWidth / 2}px`;
            element.appendChild(rippleDiv);
            setTimeout(() => {
                rippleDiv.remove();
            }, 800);
        };
        const buttons = document.querySelectorAll('.ripple-effect, .ripple-effect-dark');
        buttons.forEach((element) => {
            element.addEventListener('click', createRipple);
        });

        return () => {
            buttons.forEach((element) => {
                element.removeEventListener('click', createRipple);
            });
        };
    }, []);

   
    return (
        <>
            <BsButton {...rest}>{children}</BsButton>
        </>
    )
}    
export default Button;